import React from 'react'
import PropTypes from 'prop-types'
import './fields.css'

export const inputField = ({
  input,
  label,
  type,
  meta: { touched, error },
}) => (
  <div>
    <label htmlFor={input.name} style={{ fontWeight: 400 }}>
      {label}
    </label>
    <input
      {...input}
      id={input.name}
      className="form-control"
      type={type || 'text'}
      placeholder={label}
    />
    {touched && error && <div className="text-danger mt-2">{error}</div>}
  </div>
)

inputField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
}

export const emailField = ({
  input,
  label,
  type,
  meta: { touched, error },
}) => (
  <div>
    <label htmlFor="realEmail" style={{ fontWeight: 400 }}>
      {label}
    </label>
    <div className="input-group mb-2">
      <div className="input-group-prepend">
        <div className="input-group-text">@</div>
      </div>
      <input
        {...input}
        type={type}
        className="form-control"
        id="realEmail"
        placeholder={label}
      />
    </div>
    <small id="emailHelp" className="form-text text-muted">
      We'll never share your email with anyone else.
    </small>
    {touched && error && <div className="text-danger mt-2">{error}</div>}
  </div>
)

emailField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
}

export const select = ({ input, label, options, meta: { touched, error } }) => (
  <div>
    <label style={{ fontWeight: 400 }}>{label}</label>
    <select {...input} className="custom-select">
      {options.map((option) => (
        <option key={option.label} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    {touched && error && <div className="text-danger mt-2">{error}</div>}
  </div>
)

select.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
  }),
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    })
  ).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
}

// checkbox field for legal purposes
export const legalField = ({
  input,
  page,
  externalPage,
  meta: { touched, error },
}) => (
  <div>
    <label>
      <input {...input} type="checkbox" />
      {/* <span className='custom-control-indicator checkBox' /> */}
      <span className="ml-2 custom-control-description">
        I have read and accepted Fit3D's&nbsp;
        <a
          href={externalPage}
          tabIndex="-1"
          target="_blank"
          rel="noopener noreferrer"
        >
          {page}
        </a>
        .
      </span>
    </label>
    {/* <br /> */}
    {touched && error && <div className="text-danger mb-2">{error}</div>}
  </div>
)

legalField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  type: PropTypes.string,
  page: PropTypes.string.isRequired,
  externalPage: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
}
